<aside class="bg-surface-container-lowest flex flex-col h-full w-64">

  <!-- Brand -->
  <div class="px-5 py-5 flex items-center gap-3 shrink-0">
    <div class="w-8 h-8 rounded-lg bg-white flex items-center justify-center shrink-0">
      <img src="/assets/tp_logo.svg" alt="TP Logo" class="w-5 h-5" />
    </div>
    <div class="overflow-hidden">
      <p class="text-on-surface-low font-semibold text-sm leading-tight truncate">Expedia Voyager</p>
      <p class="text-inactive text-xs leading-tight truncate">Data Extraction</p>
    </div>
  </div>

  <!-- Top navigation -->
  <nav class="flex-1 px-3 py-2 overflow-y-auto min-h-0">
    <p class="px-3 mb-2 text-xs font-semibold text-inactive uppercase tracking-wider">
      Configuration
    </p>
    @for (item of topItems; track item.label) {
      @if (item.children ? visibleChildren(item).length > 0 : isVisible(item)) {
      @if (item.children && item.children.length > 0) {
        <!-- Parent item with children -->
        <div class="mb-0.5">
          <button type="button"
                  (click)="toggleItem(item)"
                  class="w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-colors duration-150 text-left"
                  [class.text-on-surface-low]="true">
            <span class="flex items-center justify-center w-8 h-8 shrink-0">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      [attr.d]="item.svgPath" />
              </svg>
            </span>
            <span class="text-sm font-medium truncate flex-1">{{ item.label }}</span>
            <svg class="w-4 h-4 shrink-0 transition-transform duration-150"
                 [class.rotate-90]="isExpanded(item)"
                 fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>

          @if (isExpanded(item)) {
            <div class="mt-0.5 ml-4 space-y-0.5">
              @for (child of visibleChildren(item); track child.label) {
                <button type="button"
                        (click)="navigate(child)"
                        class="w-full flex items-center gap-2.5 pl-7 pr-3 py-2 rounded-lg transition-colors duration-150 text-left"
                        [class.bg-primary]="isActive(child)"
                        [class.text-on-primary]="isActive(child)"
                        [class.text-on-surface-low]="!isActive(child)"
                        [class.hover:bg-white]="!isActive(child)">
                  @if (child.svgPath) {
                    <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            [attr.d]="child.svgPath" />
                    </svg>
                  } @else {
                    <span class="w-1.5 h-1.5 rounded-full shrink-0"
                          [class.bg-on-primary]="isActive(child)"
                          [class.bg-inactive]="!isActive(child)"></span>
                  }
                  <span class="text-sm font-medium truncate">{{ child.label }}</span>
                </button>
              }
            </div>
          }
        </div>
      } @else {
        <!-- Leaf item -->
        <button type="button"
                (click)="navigate(item)"
                class="w-full flex items-center gap-3 px-3 py-2 rounded-lg
                       transition-colors duration-150 text-left mb-0.5"
                [class.bg-primary]="isActive(item)"
                [class.text-on-primary]="isActive(item)"
                [class.text-on-surface-low]="!isActive(item)"
                [class.hover:bg-white]="!isActive(item)">
          <span class="flex items-center justify-center w-8 h-8 shrink-0">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    [attr.d]="item.svgPath" />
            </svg>
          </span>
          <span class="text-sm font-medium truncate">{{ item.label }}</span>
        </button>
      }
      }
    }
  </nav>

  <!-- Bottom section -->
  <div class="px-3 pb-3 pt-2 border-t border-white/10 shrink-0">
    @for (item of bottomItems; track item.label) {
      @if (item.children ? visibleChildren(item).length > 0 : isVisible(item)) {
      @if (item.children && item.children.length > 0) {
        <div class="mb-0.5">
          <button type="button"
                  (click)="toggleItem(item)"
                  class="w-full flex items-center gap-3 px-3 py-2 rounded-lg transition-colors duration-150 text-left"
                  [class.text-on-surface-low]="true">
            <span class="flex items-center justify-center w-8 h-8 shrink-0">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      [attr.d]="item.svgPath" />
              </svg>
            </span>
            <span class="text-sm font-medium truncate flex-1">{{ item.label }}</span>
            <svg class="w-4 h-4 shrink-0 transition-transform duration-150"
                 [class.rotate-90]="isExpanded(item)"
                 fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
          @if (isExpanded(item)) {
            <div class="mt-0.5 ml-4 space-y-0.5">
              @for (child of visibleChildren(item); track child.label) {
                <button type="button"
                        (click)="navigate(child)"
                        class="w-full flex items-center gap-2.5 pl-7 pr-3 py-2 rounded-lg transition-colors duration-150 text-left"
                        [class.bg-primary]="isActive(child)"
                        [class.text-on-primary]="isActive(child)"
                        [class.text-on-surface-low]="!isActive(child)"
                        [class.hover:bg-white]="!isActive(child)">
                  @if (child.svgPath) {
                    <svg class="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            [attr.d]="child.svgPath" />
                    </svg>
                  } @else {
                    <span class="w-1.5 h-1.5 rounded-full shrink-0"
                          [class.bg-on-primary]="isActive(child)"
                          [class.bg-inactive]="!isActive(child)"></span>
                  }
                  <span class="text-sm font-medium truncate">{{ child.label }}</span>
                </button>
              }
            </div>
          }
        </div>
      } @else {
        <button type="button"
                (click)="navigate(item)"
                class="w-full flex items-center gap-3 px-3 py-2 rounded-lg
                       transition-colors duration-150 text-left mb-0.5"
                [class.bg-primary]="isActive(item)"
                [class.text-on-primary]="isActive(item)"
                [class.text-on-surface-low]="!isActive(item)"
                [class.hover:bg-white]="!isActive(item)">
          <span class="flex items-center justify-center w-8 h-8 shrink-0">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    [attr.d]="item.svgPath" />
            </svg>
          </span>
          <span class="text-sm font-medium truncate">{{ item.label }}</span>
        </button>
      }
      }
    }
    <!-- Logout -->
    <button type="button" (click)="logout()"
            class="w-full flex items-center gap-3 px-3 py-2 rounded-lg mt-1
                   transition-colors duration-150 text-left
                   text-on-surface-low hover:bg-white">
      <span class="flex items-center justify-center w-8 h-8 shrink-0">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
        </svg>
      </span>
      <span class="text-sm font-medium truncate">Sign out</span>
    </button>

    <p class="mt-3 px-3 text-xs text-inactive">v1.0.0</p>
  </div>

</aside>
